import { ErrorMessage } from '@hookform/error-message';
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import { Card } from "reactstrap";
import { Block, BlockHead, BlockHeadContent, BlockTitle, Button, Col, Icon, Row } from "../../components/Component";
import { GET, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";

const DEFAULT_USER = {
  id: null,
  name: "",
  holyName: null,
  church: null,
  diocese: null,
  phone: null,
  email: null
}

const UserProfileLayout = () => {
  const [loading, setLoading] = useState(false);
  const [passState, setPassState] = useState(false);
  const [password, setPassword] = useState('');
  // const [passStateRepeat, setPassStateRepeat] = useState(false);

  const { errors, register, handleSubmit, reset, getValues, control } = useForm({
  });

  useEffect(() => {
    setLoading(true);

    GET(`user/info`, {}, true)
      .then(({ data }) => {
        delete (data?.password)
        reset(data)
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error || 'Có lỗi xảy ra! Vui lòng thử lại.');

      })
      .finally(() => {
        setLoading(false);
      })

  }, []);

  const onFormSubmit = () => {
    setLoading(true);

    const data = getValues();
    if (password !== '') {
      data.password = password;
    }

    PUT(`user/profile`, data, {}, true)
      .then(res => {
        toast.success('Lưu thành công');
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error || 'Có lỗi xảy ra! Vui lòng thử lại.');

      })
      .finally(() => {
        setLoading(false)
      });
  }

  return (
    <React.Fragment>
      <Content>
        <form onSubmit={handleSubmit(onFormSubmit)}>
          <Block>
            <Row className="gy-5">
              <Col lg="6">
                <BlockHead>
                  <BlockHeadContent>
                    <BlockTitle tag="h5">Thông tin cá nhân</BlockTitle>
                  </BlockHeadContent>
                </BlockHead>
                <Card className="card-bordered">
                  <ul className="data-list is-compact">
                    <li className="data-item">
                      <div className="data-col">
                        <div className="data-label">username</div>
                        <div className="data-value w-100">
                          <input
                            disabled
                            className="form-control"
                            name="username"
                            ref={register({
                              required: "Field is required",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="username"
                            render={({ message }) => <span className="invalid">{message}</span>}
                          />
                        </div>
                      </div>
                    </li>
                    <li className="data-item">
                      <div className="data-col">
                        <div className="data-label">Họ và tên <span className="text-danger">*</span></div>
                        <div className="data-value w-100">
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            ref={register({
                              required: "Field is required",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="name"
                            render={({ message }) => <span className="invalid">{message}</span>}
                          />
                        </div>
                      </div>
                    </li>
                    <li className="data-item">
                      <div className="data-col">
                        <div className="data-label">Còn làm việc<span className="text-danger">*</span></div>
                        <div className="data-value w-100">
                          <Controller
                            control={control}
                            name="active"
                            render={({ onChange, value, name, ref }) => (
                              <input
                                disabled={true}
                                type="checkbox"
                                checked={!!value}
                                name={name}
                                onChange={(e) => onChange(e.target.checked)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="vnid"
                            render={({ message }) => <span className="invalid">{message}</span>}
                          />
                        </div>
                      </div>
                    </li>
                  </ul>
                </Card>
              </Col>

              <Col lg="6">
                <BlockHead>
                  <BlockHeadContent>
                    <BlockTitle tag="h5">Đổi mật khẩu</BlockTitle>
                  </BlockHeadContent>
                </BlockHead>
                <Card className="card-bordered">
                  <ul className="data-list is-compact">
                    <li className="data-item">
                      <div className="data-col">
                        <div className="data-label">Mật khẩu mới</div>
                        <div className="data-value w-100">
                          <div className="form-control-wrap">
                            <a
                              href="#password"
                              onClick={(ev) => {
                                ev.preventDefault();
                                setPassState(!passState);
                              }}
                              className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                            >
                              <Icon name="eye" className="passcode-icon icon-show"></Icon>

                              <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                            </a>
                            <input
                              type={passState ? "text" : "password"}
                              name="password"
                              placeholder="Nhập mật khẩu mới"
                              className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`}
                              onChange={(e) => {
                                setPassword(e.target.value);
                              }}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="password"
                              render={({ message }) => <span className="invalid">{message}</span>}
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </Card>

              </Col>
              <br></br>
              <Col lg="12">
                <Button disabled={loading} className={'mt-2'} color='success'>Lưu thông tin</Button>
              </Col>
            </Row>
          </Block>
        </form>
      </Content>
    </React.Fragment>
  );
};

export default UserProfileLayout;
